
import React from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";

interface SpamFolderAlertProps {
  show: boolean;
}

const SpamFolderAlert: React.FC<SpamFolderAlertProps> = ({ show }) => {
  if (!show) return null;
  
  return (
    <Alert className="bg-blue-50 border-blue-200 mt-4">
      <Info className="h-4 w-4 text-blue-500" />
      <AlertDescription className="text-blue-700 text-sm">
        If you don't see the verification email in your inbox, please check your spam/junk folder.
      </AlertDescription>
    </Alert>
  );
};

export default SpamFolderAlert;
